import { Table, TableProps } from '@otp/ui';
import { useTranslation } from 'react-i18next';
import { getTableConfig } from './config';
import { UserCertificateListItem } from 'src/components/organisation/manage-otps/user-details/user-certificates/types';

type UserCertificatesTableProps = Omit<TableProps, 'columns'> & {
  className?: string;
  data: Array<UserCertificateListItem>;
  withoutActions: boolean;
};

export const UserCertificatesTable = ({
  data,
  className,
  options,
  withoutActions,
  ...props
}: UserCertificatesTableProps) => {
  const { t } = useTranslation();
  const tableConfig = getTableConfig(data, { t, withoutActions });

  return (
    <div className={className}>
      <Table options={options} {...props} data={data} columns={tableConfig} />
    </div>
  );
};
